import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CourseCatalogueService {
  public course_list;
  constructor() { }
  // getCourses(){
  //   this.course_list = [
  //     {co_id:1,title:'CSE101',s_desc:'short description', f_desc:'full description',unit:2},
  //     {co_id:2,title:'CSE102',s_desc:'short description', f_desc:'full description',unit:2},
  //     {co_id:3,title:'CSE103',s_desc:'short description', f_desc:'full description',unit:3},
  //     {co_id:4,title:'CSE201',s_desc:'short description', f_desc:'full description',unit:1},
  //     {co_id:5,title:'CSE201',s_desc:'short description', f_desc:'full description',unit:4},
  //     {co_id:6,title:'CSE301',s_desc:'short description', f_desc:'full description',unit:2},
  //     {co_id:7,title:'CSE301',s_desc:'short description', f_desc:'full description',unit:3},
  //     {co_id:8,title:'CSE401',s_desc:'short description', f_desc:'full description',unit:1},
  //     {co_id:9,title:'MEE301',s_desc:"short desc",f_desc:'full_desc',unit:1}
      
  //   ];
  //   return this.course_list[0].title;
  // }
 

}
